import axios from 'axios';
import htmlParser from 'node-html-parser';
import React from 'react';

import HtmlText from 'Components/HtmlText';
import { ModalItem } from 'context/ModalContext/ModalContext';
import ModalFailed from 'pages/ModalFailed/ModalFailed';
import { externalLinks } from 'utils/constants';

export default class PrivacyModal {
  private content: ModalItem | undefined;
  private lastFetched: number;

  constructor() {
    this.lastFetched = 0;
    this.getDetails = this.getDetails.bind(this);
  }

  async getDetails() {
    if (!this.content || this.lastFetched + 30 * 60 * 1000 < +new Date()) {
      try {
        const res = await axios.get(externalLinks.privacyPolicy);

        const document = htmlParser(res.data);
        this.lastFetched = +new Date();
        this.content = {
          title: document.querySelector('#main header h1').childNodes[0].innerText,
          children: (
            <HtmlText>
              {document
                .querySelector('#main .cm-rich-text')
                .toString()
                // Ensure absolute links
                .replace(
                  /href="\/([^"]+)"/g,
                  (_, value) => `href="https://www.service.vic.gov.au/${value}"`
                )
                // Ensure blank targets
                .replace(/<a /g, '<a target="_blank" ')}
            </HtmlText>
          )
        };
      } catch (e) {
        this.content = {
          title: "There's a problem fetching the latest data",
          children: <ModalFailed privacyModal={this} />
        };
      }
    }

    return this.content;
  }
}
